// extracted by mini-css-extract-plugin
export default {"picture":"picture_picture__xZi8i","text":"picture_text__CY0L8"};